/**
 * @generated SignedSource<<6c42ed9de5c189b68ae31c15af2392ec>>
 * @relayHash 4ecf39229258cea2d28cf8c3fcf0018e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d90f9685fdc33683e28f5d615e3982868e263e0320c38efa34bb06cd801f4bd7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAtlassianIntelligenceFeatureEnum = "AI_MATE" | "NATURAL_LANGUAGE_TO_JQL" | "%future added value";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_BOARD" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null;
  customInput?: JiraIssueSearchCustomInput | null;
  filterId?: string | null;
  groupByInput?: JiraIssueSearchGroupByInput | null;
  jql?: string | null;
  searchWithLastUsedJql?: boolean | null;
};
export type JiraIssueSearchChildIssuesInput = {
  applyJqlFilter?: boolean | null;
  filterByProjectKeys?: ReadonlyArray<string> | null;
  filterId?: string | null;
  jql?: string | null;
  namespace?: string | null;
  parentIssueKey: string;
  viewId?: string | null;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null;
  context?: JiraSoftwareIssueSearchCustomInputContext | null;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null;
  hideUnParentedItems?: boolean | null;
  maxHierarchyLevel?: number | null;
  quickFilterIds?: ReadonlyArray<string> | null;
  useSavedFilters?: boolean | null;
};
export type JiraIssueSearchGroupByInput = {
  groupByJql?: string | null;
  jql?: string | null;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null;
  viewInput?: JiraIssueSearchViewInput | null;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null;
  filterId?: string | null;
  namespace?: string | null;
  viewId?: string | null;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null;
  project?: string | null;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null;
  isGroupingEnabled?: boolean | null;
  isHideDoneEnabled?: boolean | null;
  isHierarchyEnabled?: boolean | null;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null;
  canEnableAggregation?: boolean | null;
  fieldAggregationQueryInput?: JiraFieldAggregationQueryInput | null;
  maxHierarchyLevel?: number | null;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null;
  fieldId?: string | null;
  isEnabled?: boolean | null;
};
export type JiraFieldAggregationQueryInput = {
  boardQuery?: JiraFieldAggregationByBoardQuery | null;
  projectQuery?: JiraFieldAggregationByProjectQuery | null;
  viewId?: string | null;
};
export type JiraFieldAggregationByBoardQuery = {
  boardId: AGG$Long;
  cloudId: string;
};
export type JiraFieldAggregationByProjectQuery = {
  cloudId: string;
  projectIdOrKey: JiraFieldAggregationProjectIdOrKeyInput;
};
export type JiraFieldAggregationProjectIdOrKeyInput = {
  projectId?: AGG$Long | null;
  projectKey?: string | null;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null;
  viewInput?: JiraIssueSearchViewInput | null;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null;
  projectKey?: string | null;
};
export type JiraViewQueryInput = {
  boardIdAndItemQuery?: JiraViewBoardIdAndItemQuery | null;
  projectKeyAndItemQuery?: JiraViewProjectKeyAndItemQuery | null;
  subcontainerIdAndItemQuery?: JiraViewSubcontainerIdAndItemQuery | null;
  viewId?: string | null;
};
export type JiraViewBoardIdAndItemQuery = {
  boardId: AGG$Long;
  cloudId: string;
  itemId: string;
};
export type JiraViewProjectKeyAndItemQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraViewSubcontainerIdAndItemQuery = {
  cloudId: string;
  itemId: string;
  subcontainerId: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null;
  hideDone?: boolean | null;
  hierarchyEnabled?: boolean | null;
  jql?: string | null;
};
export type main_IssueNavigatorQuery$variables = {
  after?: string | null;
  amountOfColumns: number;
  atlassianIntelligenceProductFeature: JiraAtlassianIntelligenceFeatureEnum;
  before?: string | null;
  cloudId: string;
  dynamicSearchKey?: string | null;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null;
  fieldSetsScope?: JiraIssueSearchScope | null;
  filterId?: string | null;
  first?: number | null;
  groupBy?: string | null;
  isPaginating?: boolean | null;
  issueSearchInput: JiraIssueSearchInput;
  jiraViewQueryInput?: JiraViewQueryInput | null;
  last?: number | null;
  namespace?: string | null;
  options?: JiraIssueSearchOptions | null;
  projectKey: string;
  saveJQLToUserHistory?: boolean | null;
  scope?: JiraIssueSearchScope | null;
  settings?: JiraIssueSearchSettings | null;
  shouldQueryConditionalFormatting: boolean;
  shouldQueryConditionalFormattingFromSavedView: boolean;
  shouldQueryHasChildrenWithCount?: boolean | null;
  shouldQueryProject: boolean;
  shouldQueryRankField?: boolean | null;
  shouldQuerySaveResetViewSettingsButton: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null;
  viewId?: string | null;
};
export type main_IssueNavigatorQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey?: {
      readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingInner" | "ConditionalFormattingSidebarContainer_project" | "IssueNavigatorUIComponent_project_jiraProject" | "IssueSearch_issueNavigatorProject">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"main_IssueNavigatorIssueNavigator_IssueNavigator_jira">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"main_IssueNavigatorIssueNavigator_IssueNavigator_issueQuery">;
};
export type main_IssueNavigatorQuery = {
  response: main_IssueNavigatorQuery$data;
  variables: main_IssueNavigatorQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider": isOrderByRankEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider": isNinDecoupledJqlValidationFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider": isNinIssuePreviewPanelChangeboardingEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled": isIssueSearchWarningsEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider": isTimelineHarmonisationM3PerformanceDisabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFrontierFormulaFieldD2D3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled": isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssueAppConditionalEntrypointSsrEnabledRelayProvider": isNinIssueAppConditionalEntrypointSsrEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled": isJiraSpreadsheetGroupSearchWarningsEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueTableFlatListInitialisationFixEnabledRelayProvider": isIssueTableFlatListInitialisationFixEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisCrossGroupDndEnabledRelayProvider": isCrossGroupDndEnabled_provider,
  "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": isProjectsInJiraM1Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider,
  "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderGroupByAgentSessionsSubPropertyRelayProvider": isGroupByAgentSessionsSubPropertyEnabled_provider,
  "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": isPrivateGoalsInListViewGroupHeaderEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": isAdditionalFieldsInGroupByProjectHeaderEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": isGuidedAutonomyEapEnabled_provider
} as {
  readonly __relay_internal__pv__jiraissuetable__groupingsrcrelayproviderGroupByAgentSessionsSubPropertyRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider: {
    readonly get: () => number | null;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisCrossGroupDndEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueTableFlatListInitialisationFixEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssueAppConditionalEntrypointSsrEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider: {
    readonly get: () => boolean;
  };
});

import isGroupByAgentSessionsSubPropertyEnabled_provider from '@jira/issue-table__grouping/src/relay-provider/GroupByAgentSessionsSubPropertyRelayProvider';
import isPrivateGoalsInListViewGroupHeaderEnabled_provider from '@jira/issue-table__grouping/src/relay-provider/PrivateGoalsInJiraRelayProvider';
import isProjectsInJiraM1Enabled_provider from '@jira/issue-table__grouping/src/relay-provider/projects-in-jira-m1.relayprovider';
import shouldFetchDelegatorForList_provider from '@jira/platform__graphql-relay-provider/src/EmpanadaAssigneeAgentDelegateFixRelayprovider';
import isFrontierFormulaFieldD2D3Enabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierFormulaFieldD2D3Relayprovider';
import isGuidedAutonomyEapEnabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierGuidedAutonomyEapRelayProvider';
import isDateRangeFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/IssueTableDateRangeFieldRelayProvider';
import isTimelineHarmonisationM3PerformanceDisabled_provider from '@jira/platform__graphql-relay-provider/src/JiraTimelineHarmonisationM3PerformanceDisabledRelayProvider';
import isColouredDueDateUiChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/JivColouredDueDateUiChangesRelayprovider';
import shouldSurfaceAgentAssignee_provider from '@jira/platform__graphql-relay-provider/src/JsmSurfaceAgentAssigneeRelayProvider';
import caterRichTextWithPlainTextRenderer_provider from '@jira/platform__graphql-relay-provider/src/NinCaterRichTextWithPlainTextRendererRelayProvider';
import isFieldCellExtractionEnabled_provider from '@jira/platform__graphql-relay-provider/src/NinFieldCellExtractionRelayProvider';
import isPrivateGoalsFieldReadEnabled_provider from '@jira/platform__graphql-relay-provider/src/PrivateGoalsInJiraRelayProvider';
import isUseNodeIdForRowKeyDisabled_provider from '@jira/platform__graphql-relay-provider/src/UseNodeIdForRowKeyDisabledRelayProvider';
import isAdditionalFieldsInGroupByProjectHeaderEnabled_provider from '@jira/platform__graphql-relay-provider/src/additionalFieldsInGroupByProjectHeaderRelayProvider';
import cmdbFirst_provider from '@jira/platform__graphql-relay-provider/src/assets-custom-fields-limit-increase.relayprovider';
import isAtlasProjectEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration.relayprovider';
import isFormulaFieldD1Enabled_provider from '@jira/platform__graphql-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@jira/platform__graphql-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@jira/platform__graphql-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isPaidListNinMergeOnboardingModalEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jira-paid-list-nin-merge-onboarding-modal-enabled.relayprovider';
import isJscIFCEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSavedViewConditionalFormattingEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-conditional-formatting-enabled.relayprovider';
import isSavedListViewEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-enabled.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isCrossGroupDndEnabled_provider from '@jira/platform__graphql-relay-provider/src/isCrossGroupDndEnabledRelayProvider';
import isIssueSearchWarningsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isIssueSearchWarningsEnabled';
import isIssueTableFlatListInitialisationFixEnabled_provider from '@jira/platform__graphql-relay-provider/src/isIssueTableFlatListInitialisationFixEnabledRelayProvider';
import isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraForgeCustomFieldsInIssueNavigatorEditEnabled';
import isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraForgeCustomFieldsInIssueNavigatorEnabled.relayprovider';
import isJiraSpreadsheetGroupSearchWarningsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraSpreadsheetGroupSearchWarningsEnabled';
import isNinIssueAppConditionalEntrypointSsrEnabled_provider from '@jira/platform__graphql-relay-provider/src/isNinIssueAppConditionalEntrypointSsrEnabledRelayProvider';
import isNinIssuePreviewPanelChangeboardingEnabled_provider from '@jira/platform__graphql-relay-provider/src/isNinIssuePreviewPanelChangeboardingEnabledRelayProvider';
import isColorFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/issue-table-color-field.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchDelegator_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNinDecoupledJqlValidationFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/nin-decoupled-jql-validation-field.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@jira/platform__graphql-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';
import isOrderByRankEnabled_provider from '@jira/platform__graphql-relay-provider/src/pnin-jql-order-by-rank.relayprovider';
import isProjectsInJiraGaDropEnabled_provider from '@jira/platform__graphql-relay-provider/src/projectsInJiraGaDropRelayProvider';
import isUseNodeIdForRowKeyEnabled_provider from '@jira/platform__graphql-relay-provider/src/use-node-id-for-row-key.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianIntelligenceProductFeature"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynamicSearchKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraViewQueryInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormatting"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormattingFromSavedView"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildrenWithCount"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryProject"
},
v25 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryRankField"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQuerySaveResetViewSettingsButton"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v30 = {
  "kind": "Variable",
  "name": "isConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormatting"
},
v31 = {
  "kind": "Variable",
  "name": "isSavedViewConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormattingFromSavedView"
},
v32 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v33 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v34 = [
  (v33/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v36 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v37 = {
  "kind": "Variable",
  "name": "jiraViewQueryInput",
  "variableName": "jiraViewQueryInput"
},
v38 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v39 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v40 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v41 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v42 = {
  "kind": "ScalarField",
  "name": "message"
},
v43 = [
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v40/*: any*/),
      (v41/*: any*/)
    ]
  },
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "id"
},
v45 = {
  "kind": "ScalarField",
  "name": "jql"
},
v46 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "fieldSetsScope"
},
v47 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  },
  (v46/*: any*/)
],
v48 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v49 = {
  "kind": "ScalarField",
  "name": "savedViewId"
},
v50 = {
  "args": [
    (v39/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isViewConfigModified"
},
v51 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v52 = [
  (v51/*: any*/),
  (v36/*: any*/),
  (v39/*: any*/),
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v53 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v54 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v53/*: any*/),
        (v44/*: any*/)
      ]
    }
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v56 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v57 = {
  "kind": "ScalarField",
  "name": "__id"
},
v58 = {
  "kind": "ClientExtension",
  "selections": [
    (v57/*: any*/)
  ]
},
v59 = {
  "kind": "Variable",
  "name": "saveJQLToUserHistory",
  "variableName": "saveJQLToUserHistory"
},
v60 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v61 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v62 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v63 = {
  "kind": "ScalarField",
  "name": "type"
},
v64 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v65 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v66 = {
  "kind": "ScalarField",
  "name": "aliases"
},
v67 = {
  "kind": "ScalarField",
  "name": "value"
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v53/*: any*/),
    {
      "alias": "singleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    (v67/*: any*/)
  ],
  "type": "JiraFormattingSingleValueOperand"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v53/*: any*/),
    {
      "alias": "multipleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    {
      "kind": "ScalarField",
      "name": "values"
    }
  ],
  "type": "JiraFormattingMultipleValueOperand"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v53/*: any*/),
    {
      "alias": "noValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    }
  ],
  "type": "JiraFormattingNoValueOperand"
},
v71 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v68/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/)
  ]
},
v72 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v73 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v74 = [
  {
    "concreteType": "JiraFormattingRuleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraFormattingRule",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v71/*: any*/),
          (v72/*: any*/),
          {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "formattingColor",
            "plural": false,
            "selections": [
              (v44/*: any*/),
              (v73/*: any*/)
            ]
          },
          (v44/*: any*/)
        ]
      }
    ]
  }
],
v75 = [
  (v73/*: any*/),
  (v44/*: any*/)
],
v76 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "formattingColor",
  "plural": false,
  "selections": (v75/*: any*/)
},
v77 = {
  "kind": "ScalarField",
  "name": "name"
},
v78 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v79 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v80 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v81 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v82 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v83 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v84 = [
  (v78/*: any*/),
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v36/*: any*/),
  (v82/*: any*/),
  (v83/*: any*/),
  (v59/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/)
],
v85 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v86 = {
  "kind": "ScalarField",
  "name": "key"
},
v87 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v88 = [
  (v77/*: any*/),
  (v44/*: any*/)
],
v89 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v90 = {
  "kind": "ScalarField",
  "name": "text"
},
v91 = {
  "kind": "ScalarField",
  "name": "picture"
},
v92 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    }
  ],
  "type": "AppUser"
},
v94 = [
  (v92/*: any*/),
  (v93/*: any*/)
],
v95 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v96 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v97 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v96/*: any*/),
    (v44/*: any*/)
  ]
},
v98 = {
  "kind": "InlineFragment",
  "selections": [
    (v97/*: any*/)
  ],
  "type": "JiraStatusCategoryField"
},
v99 = {
  "concreteType": "JiraIssueEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    (v85/*: any*/),
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        (v44/*: any*/),
        (v86/*: any*/),
        (v87/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": (v88/*: any*/)
                },
                (v44/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "args": (v89/*: any*/),
      "concreteType": "JiraIssueFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v53/*: any*/),
                            (v40/*: any*/),
                            (v63/*: any*/),
                            (v44/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v90/*: any*/),
                                (v77/*: any*/)
                              ],
                              "type": "JiraSingleLineTextField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v77/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "name": "user",
                                  "plural": false,
                                  "selections": [
                                    (v40/*: any*/),
                                    (v77/*: any*/),
                                    (v91/*: any*/),
                                    (v44/*: any*/),
                                    {
                                      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                      "kind": "Condition",
                                      "passingValue": true,
                                      "selections": (v94/*: any*/)
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v77/*: any*/),
                                    (v95/*: any*/),
                                    (v44/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            (v98/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldSets(first:500)"
    },
    (v40/*: any*/)
  ]
},
v100 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v101 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v102 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v100/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v101/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v103 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    }
  ]
},
v104 = [
  {
    "kind": "Literal",
    "name": "maxCursors",
    "value": 7
  }
],
v105 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v106 = [
  (v105/*: any*/)
],
v107 = {
  "args": (v104/*: any*/),
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v106/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v106/*: any*/)
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v108 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v109 = [
  (v42/*: any*/)
],
v110 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        (v60/*: any*/)
      ],
      "type": "JiraInvalidSyntaxError"
    },
    {
      "kind": "InlineFragment",
      "selections": (v109/*: any*/),
      "type": "JiraServerError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        (v41/*: any*/)
      ],
      "type": "JiraInvalidIssueSearchInputError"
    }
  ]
},
v111 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v112 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowEdge"
},
v113 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v114 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v115 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v114/*: any*/),
        (v44/*: any*/),
        (v77/*: any*/),
        (v95/*: any*/)
      ]
    },
    (v44/*: any*/)
  ]
},
v116 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRow"
},
v117 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v97/*: any*/),
    (v44/*: any*/)
  ]
},
v118 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v117/*: any*/),
    (v44/*: any*/)
  ]
},
v119 = {
  "kind": "ScalarField",
  "name": "summary"
},
v120 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v121 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v122 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "resolutionPlanAssigneeProperty",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "jsm_resolution_plan_property"
            }
          ],
          "kind": "ScalarField",
          "name": "issuePropertyByKey",
          "storageKey": "issuePropertyByKey(key:\"jsm_resolution_plan_property\")"
        },
        {
          "concreteType": "JiraProjectField",
          "kind": "LinkedField",
          "name": "projectField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v120/*: any*/),
                (v44/*: any*/)
              ]
            },
            (v44/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            (v77/*: any*/),
            (v121/*: any*/),
            (v91/*: any*/),
            (v44/*: any*/)
          ]
        }
      ]
    }
  ]
},
v123 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v58/*: any*/)
          ],
          "type": "JiraListRow",
          "abstractKey": "__isJiraListRow"
        },
        (v122/*: any*/),
        (v58/*: any*/)
      ],
      "type": "JiraIssue"
    }
  ]
},
v124 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v122/*: any*/)
      ],
      "type": "JiraIssue"
    }
  ]
},
v125 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHighlightedIssueRow"
        }
      ]
    }
  ],
  "type": "JiraIssue"
},
v126 = {
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v113/*: any*/),
    (v115/*: any*/),
    (v116/*: any*/),
    (v118/*: any*/),
    (v119/*: any*/),
    (v123/*: any*/),
    (v58/*: any*/),
    (v124/*: any*/),
    (v125/*: any*/)
  ]
},
v127 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowFieldSetConnection"
},
v128 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowFieldSet"
},
v129 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v130 = {
  "kind": "ClientExtension",
  "selections": [
    (v129/*: any*/)
  ]
},
v131 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v77/*: any*/),
                (v44/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v132 = [
  (v67/*: any*/),
  (v44/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v133 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v132/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v132/*: any*/)
        }
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v134 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
        }
      ],
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": (v109/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v135 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v136 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v137 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v138 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "args": (v135/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v136/*: any*/),
                (v137/*: any*/),
                (v44/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v130/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v139 = {
  "kind": "ScalarField",
  "name": "date"
},
v140 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v141 = {
  "kind": "InlineFragment",
  "selections": [
    (v139/*: any*/),
    (v77/*: any*/),
    (v140/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v142 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v143 = {
  "kind": "ScalarField",
  "name": "formattedText"
},
v144 = [
  (v77/*: any*/)
],
v145 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v144/*: any*/)
},
v146 = {
  "kind": "ScalarField",
  "name": "number"
},
v147 = {
  "concreteType": "JiraLabelEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraLabel",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v144/*: any*/)
    }
  ]
},
v148 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v149 = [
  (v40/*: any*/),
  (v121/*: any*/),
  (v77/*: any*/),
  (v91/*: any*/),
  (v44/*: any*/)
],
v150 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v142/*: any*/),
        (v143/*: any*/)
      ],
      "type": "JiraForgeDatetimeField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v139/*: any*/),
        (v143/*: any*/),
        (v145/*: any*/),
        (v130/*: any*/)
      ],
      "type": "JiraForgeDateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v146/*: any*/),
        (v143/*: any*/),
        (v145/*: any*/),
        (v130/*: any*/)
      ],
      "type": "JiraForgeNumberField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v90/*: any*/),
        (v143/*: any*/),
        (v145/*: any*/),
        (v130/*: any*/)
      ],
      "type": "JiraForgeStringField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "args": (v135/*: any*/),
          "concreteType": "JiraLabelConnection",
          "kind": "LinkedField",
          "name": "selectedLabelsConnection",
          "plural": false,
          "selections": [
            (v62/*: any*/),
            (v147/*: any*/)
          ],
          "storageKey": "selectedLabelsConnection(first:1000)"
        }
      ],
      "type": "JiraForgeStringsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "selectedGroup",
          "plural": false,
          "selections": (v88/*: any*/)
        }
      ],
      "type": "JiraForgeGroupField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v148/*: any*/),
                    (v77/*: any*/),
                    (v44/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeGroupsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v149/*: any*/)
        }
      ],
      "type": "JiraForgeUserField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v149/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeUsersField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "object"
            },
            (v77/*: any*/)
          ]
        },
        (v130/*: any*/)
      ],
      "type": "JiraForgeObjectField"
    }
  ]
},
v151 = {
  "kind": "InlineFragment",
  "selections": [
    (v142/*: any*/),
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v152 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "start"
        },
        {
          "kind": "ScalarField",
          "name": "end"
        }
      ],
      "type": "JiraDateRangeField"
    }
  ]
},
v153 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v154 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v155 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v154/*: any*/),
        (v97/*: any*/),
        (v44/*: any*/)
      ]
    },
    (v58/*: any*/)
  ],
  "type": "JiraStatusField"
},
v156 = [
  (v86/*: any*/),
  (v44/*: any*/)
],
v157 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategoryProgressConnection",
      "kind": "LinkedField",
      "name": "aggregatedStatusCategory",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraStatusCategoryProgressEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraStatusCategoryProgress",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": (v156/*: any*/)
                },
                (v67/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAggregatedStatusField"
},
v158 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": (v75/*: any*/)
},
v159 = [
  (v77/*: any*/),
  (v158/*: any*/)
],
v160 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v135/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        (v62/*: any*/),
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v159/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v161 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v162 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v163 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v164 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v86/*: any*/),
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            (v158/*: any*/),
            (v44/*: any*/)
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v161/*: any*/),
                (v77/*: any*/),
                (v44/*: any*/),
                (v162/*: any*/),
                (v114/*: any*/)
              ]
            },
            (v44/*: any*/),
            (v53/*: any*/)
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            (v90/*: any*/),
            (v44/*: any*/),
            (v53/*: any*/)
          ]
        },
        (v44/*: any*/),
        (v113/*: any*/),
        (v163/*: any*/),
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v53/*: any*/),
            (v117/*: any*/)
          ]
        }
      ]
    },
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraParentIssueField"
},
v165 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v166 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v165/*: any*/),
        (v44/*: any*/)
      ]
    },
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v167 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v86/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v44/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v168 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v88/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v169 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v170 = {
  "kind": "ScalarField",
  "name": "state"
},
v171 = [
  (v44/*: any*/),
  (v169/*: any*/),
  (v77/*: any*/),
  (v170/*: any*/),
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v172 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v171/*: any*/)
            }
          ]
        }
      ]
    },
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraSprintField"
},
v173 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v174 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v94/*: any*/)
},
v175 = [
  {
    "concreteType": "JiraAdfToConvertedPlainText",
    "kind": "LinkedField",
    "name": "convertedPlainText",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "plainText"
      }
    ]
  }
],
v176 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v175/*: any*/)
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "JiraADF",
              "kind": "LinkedField",
              "name": "adfValue",
              "plural": false,
              "selections": (v175/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v177 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v161/*: any*/),
        (v44/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v178 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementOrganizationConnection",
      "kind": "LinkedField",
      "name": "selectedOrganizationsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementOrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraServiceManagementOrganization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "organizationName"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementOrganizationField"
},
v179 = {
  "kind": "Literal",
  "name": "first",
  "value": 50
},
v180 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        (v179/*: any*/)
      ],
      "concreteType": "JiraAgentSessionConnection",
      "kind": "LinkedField",
      "name": "agentSessions",
      "plural": false,
      "selections": [
        (v62/*: any*/),
        {
          "concreteType": "JiraAgentSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAgentSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v170/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/),
                    (v92/*: any*/),
                    (v91/*: any*/),
                    (v93/*: any*/),
                    (v44/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "stateCategory"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "agentSessions(first:50)"
    }
  ],
  "type": "JiraAgentSessionsField"
},
v181 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v62/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v163/*: any*/),
                    (v86/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v40/*: any*/),
                                (v98/*: any*/),
                                (v44/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    {
                      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v87/*: any*/)
                      ]
                    },
                    (v44/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v44/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v182 = {
  "kind": "ScalarField",
  "name": "formatStyle"
},
v183 = {
  "kind": "ScalarField",
  "name": "formatUnit"
},
v184 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v146/*: any*/),
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        (v182/*: any*/),
        (v183/*: any*/)
      ]
    },
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraNumberField"
},
v185 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v62/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v186 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v130/*: any*/)
  ],
  "type": "JiraUrlField"
},
v187 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v188 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v67/*: any*/),
        (v158/*: any*/),
        (v44/*: any*/),
        (v187/*: any*/)
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v189 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v67/*: any*/),
                (v187/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v190 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v44/*: any*/),
    (v67/*: any*/)
  ]
},
v191 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v190/*: any*/)
          ]
        }
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraCheckboxesField"
},
v192 = {
  "concreteType": "JiraUserConnection",
  "kind": "LinkedField",
  "name": "selectedUsersConnection",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            (v121/*: any*/),
            (v77/*: any*/),
            (v91/*: any*/),
            (v44/*: any*/),
            (v173/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ]
},
v193 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    (v192/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v194 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v195 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraEstimate",
              "kind": "LinkedField",
              "name": "originalEstimate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "timeInSeconds"
                }
              ]
            },
            {
              "concreteType": "JiraTimeTrackingSettings",
              "kind": "LinkedField",
              "name": "timeTrackingSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "workingHoursPerDay"
                },
                {
                  "kind": "ScalarField",
                  "name": "workingDaysPerWeek"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultFormat"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultUnit"
                }
              ]
            },
            (v44/*: any*/),
            (v53/*: any*/),
            (v77/*: any*/),
            (v63/*: any*/)
          ]
        },
        (v44/*: any*/)
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraOriginalTimeEstimateField"
},
v196 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "value"
},
v197 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        (v196/*: any*/),
        (v44/*: any*/),
        (v136/*: any*/)
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v198 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v199 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "args": (v135/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v77/*: any*/),
                (v136/*: any*/),
                (v137/*: any*/),
                (v198/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v130/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v200 = [
  (v44/*: any*/)
],
v201 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v200/*: any*/)
},
v202 = {
  "kind": "ScalarField",
  "name": "status"
},
v203 = [
  {
    "kind": "ScalarField",
    "name": "isPrivate"
  }
],
v204 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    (v201/*: any*/),
    {
      "args": (v135/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v86/*: any*/),
                (v77/*: any*/),
                (v202/*: any*/),
                {
                  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": (v203/*: any*/)
                }
              ]
            }
          ]
        },
        (v58/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v57/*: any*/),
        (v129/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v205 = {
  "kind": "ScalarField",
  "name": "privateProject"
},
v206 = {
  "kind": "ScalarField",
  "name": "hasPermission"
},
v207 = {
  "kind": "ScalarField",
  "name": "isWorkspaceActive"
},
v208 = {
  "kind": "ScalarField",
  "name": "iconName"
},
v209 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v77/*: any*/),
        (v201/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isLinkEditable"
        },
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            {
              "alias": "atlasProjectName",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "alias": "atlasProjectKey",
              "kind": "ScalarField",
              "name": "key"
            },
            (v205/*: any*/),
            (v206/*: any*/),
            (v207/*: any*/),
            (v208/*: any*/)
          ]
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isLinkInherited"
            },
            {
              "kind": "ScalarField",
              "name": "isParentLinked"
            }
          ]
        },
        (v130/*: any*/)
      ],
      "type": "JiraTownsquareProjectField"
    }
  ]
},
v210 = {
  "kind": "ScalarField",
  "name": "href"
},
v211 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "args": (v135/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v210/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "pageContent",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v210/*: any*/)
                      ],
                      "type": "JiraConfluencePageContentDetails"
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v62/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v130/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v212 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v77/*: any*/),
                (v148/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v130/*: any*/)
  ],
  "type": "JiraMultipleGroupPickerField"
},
v213 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
},
v214 = {
  "kind": "ScalarField",
  "name": "count"
},
v215 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        (v214/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
},
v216 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    (v146/*: any*/),
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        (v182/*: any*/),
        (v183/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "durationUnits"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberFormulaField"
},
v217 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v77/*: any*/),
        (v90/*: any*/)
      ],
      "type": "JiraTextFormulaField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v142/*: any*/),
        (v77/*: any*/)
      ],
      "type": "JiraDateFormulaField"
    }
  ]
},
v218 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isMulti"
    },
    (v192/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraPeopleField"
},
v219 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v158/*: any*/)
      ],
      "type": "JiraColorField"
    }
  ]
},
v220 = [
  (v214/*: any*/)
],
v221 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v222 = {
  "kind": "ScalarField",
  "name": "stateCount"
},
v223 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueDevSummary",
      "kind": "LinkedField",
      "name": "devSummary",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        {
          "concreteType": "JiraIssueBranchDevSummaryContainer",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBranchDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v220/*: any*/)
            }
          ]
        },
        {
          "concreteType": "JiraIssueCommitDevSummaryContainer",
          "kind": "LinkedField",
          "name": "commit",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueCommitDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v214/*: any*/),
                (v221/*: any*/)
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssuePullRequestDevSummaryContainer",
          "kind": "LinkedField",
          "name": "pullrequest",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssuePullRequestDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v221/*: any*/),
                (v222/*: any*/),
                (v170/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "open"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueReviewDevSummaryContainer",
          "kind": "LinkedField",
          "name": "review",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueReviewDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v221/*: any*/),
                (v222/*: any*/),
                (v170/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "completed"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueBuildDevSummaryContainer",
          "kind": "LinkedField",
          "name": "build",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBuildDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v214/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "failedBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "successfulBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "unknownBuildCount"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
          "kind": "LinkedField",
          "name": "deploymentEnvironments",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v220/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v113/*: any*/),
        (v86/*: any*/),
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": (v200/*: any*/)
        },
        (v44/*: any*/)
      ]
    }
  ],
  "type": "JiraDevSummaryField"
},
v224 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "durationInSeconds"
    },
    (v90/*: any*/)
  ],
  "type": "JiraDurationField"
},
v225 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementFeedback",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "rating"
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestFeedbackField"
},
v226 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementSla",
      "kind": "LinkedField",
      "name": "sla",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementSlaError",
          "kind": "LinkedField",
          "name": "error",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "errorCode"
            },
            {
              "kind": "ScalarField",
              "name": "goalId"
            },
            {
              "kind": "ScalarField",
              "name": "timeMetricId"
            }
          ]
        },
        {
          "concreteType": "JiraServiceManagementSlaGoalView",
          "kind": "LinkedField",
          "name": "goalView",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "paused"
            },
            {
              "kind": "ScalarField",
              "name": "active"
            },
            {
              "kind": "ScalarField",
              "name": "closed"
            },
            {
              "kind": "ScalarField",
              "name": "failed"
            },
            {
              "kind": "ScalarField",
              "name": "emergencyLevel"
            },
            {
              "kind": "ScalarField",
              "name": "remainingTime"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementSlaField"
},
v227 = [
  (v90/*: any*/)
],
v228 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v227/*: any*/),
          "type": "JiraRemoteSingleLineTextField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "avatarUrl"
            },
            {
              "kind": "ScalarField",
              "name": "issueTypeName"
            }
          ],
          "type": "JiraRemoteIssueTypeField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "priorityName"
            },
            {
              "kind": "ScalarField",
              "name": "priorityIconUrl"
            }
          ],
          "type": "JiraRemotePriorityField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "userDisplayName"
            },
            {
              "kind": "ScalarField",
              "name": "avatarSmall"
            }
          ],
          "type": "JiraRemoteSingleSelectUserPickerField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v154/*: any*/),
            {
              "kind": "ScalarField",
              "name": "statusName"
            },
            (v96/*: any*/)
          ],
          "type": "JiraRemoteStatusField"
        },
        {
          "kind": "InlineFragment",
          "selections": (v144/*: any*/),
          "type": "JiraRemoteGenericField"
        }
      ],
      "type": "JiraRemoteIssueField",
      "abstractKey": "__isJiraRemoteIssueField"
    }
  ]
},
v229 = {
  "kind": "InlineFragment",
  "selections": [
    (v90/*: any*/),
    (v77/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v230 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v96/*: any*/),
        (v44/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v231 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v95/*: any*/),
        (v77/*: any*/),
        (v44/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v232 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/),
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        (v77/*: any*/),
        (v91/*: any*/),
        (v173/*: any*/),
        (v44/*: any*/),
        (v121/*: any*/),
        (v174/*: any*/),
        (v93/*: any*/)
      ]
    },
    (v140/*: any*/),
    (v130/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v233 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v131/*: any*/),
            (v180/*: any*/),
            (v133/*: any*/),
            (v134/*: any*/),
            (v138/*: any*/),
            (v141/*: any*/),
            (v150/*: any*/),
            (v151/*: any*/),
            (v217/*: any*/),
            (v152/*: any*/),
            (v153/*: any*/),
            (v229/*: any*/),
            (v230/*: any*/),
            (v155/*: any*/),
            (v157/*: any*/),
            (v160/*: any*/),
            (v231/*: any*/),
            (v164/*: any*/),
            (v166/*: any*/),
            (v167/*: any*/),
            (v168/*: any*/),
            (v172/*: any*/),
            (v232/*: any*/),
            (v176/*: any*/),
            (v177/*: any*/),
            (v178/*: any*/),
            (v181/*: any*/),
            (v184/*: any*/),
            (v185/*: any*/),
            (v186/*: any*/),
            (v188/*: any*/),
            (v189/*: any*/),
            (v191/*: any*/),
            (v193/*: any*/),
            (v194/*: any*/),
            (v195/*: any*/),
            (v197/*: any*/),
            (v199/*: any*/),
            (v204/*: any*/),
            (v209/*: any*/),
            (v211/*: any*/),
            (v212/*: any*/),
            (v213/*: any*/),
            (v215/*: any*/),
            (v216/*: any*/),
            (v218/*: any*/),
            (v219/*: any*/),
            (v223/*: any*/),
            (v224/*: any*/),
            (v225/*: any*/),
            (v226/*: any*/)
          ],
          "type": "JiraIssueField",
          "abstractKey": "__isJiraIssueField"
        }
      ]
    }
  ]
},
v234 = [
  (v139/*: any*/)
],
v235 = [
  (v146/*: any*/)
],
v236 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v237 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v238 = [
  (v198/*: any*/),
  (v44/*: any*/)
],
v239 = [
  (v40/*: any*/),
  (v44/*: any*/)
],
v240 = {
  "args": (v89/*: any*/),
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v127/*: any*/),
    {
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v40/*: any*/),
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            (v63/*: any*/),
            (v48/*: any*/),
            (v128/*: any*/),
            {
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                (v40/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v40/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v130/*: any*/)
                              ],
                              "type": "JiraSingleLineTextField"
                            }
                          ],
                          "type": "JiraIssueField",
                          "abstractKey": "__isJiraIssueField"
                        },
                        {
                          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                          "kind": "Condition",
                          "passingValue": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v131/*: any*/),
                                (v133/*: any*/),
                                (v134/*: any*/),
                                (v138/*: any*/),
                                (v141/*: any*/),
                                (v150/*: any*/),
                                (v151/*: any*/),
                                (v152/*: any*/),
                                (v153/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "JiraStatusCategory",
                                      "kind": "LinkedField",
                                      "name": "statusCategory",
                                      "plural": false,
                                      "selections": (v144/*: any*/)
                                    }
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v155/*: any*/),
                                (v157/*: any*/),
                                (v160/*: any*/),
                                (v164/*: any*/),
                                (v166/*: any*/),
                                (v167/*: any*/),
                                (v168/*: any*/),
                                (v172/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "name": "user",
                                      "plural": false,
                                      "selections": [
                                        (v173/*: any*/),
                                        (v121/*: any*/),
                                        (v174/*: any*/),
                                        (v93/*: any*/)
                                      ]
                                    },
                                    (v140/*: any*/),
                                    (v130/*: any*/)
                                  ],
                                  "type": "JiraSingleSelectUserPickerField"
                                },
                                (v176/*: any*/),
                                (v177/*: any*/),
                                (v178/*: any*/),
                                (v180/*: any*/),
                                (v181/*: any*/),
                                (v184/*: any*/),
                                (v185/*: any*/),
                                (v186/*: any*/),
                                (v188/*: any*/),
                                (v189/*: any*/),
                                (v191/*: any*/),
                                (v193/*: any*/),
                                (v194/*: any*/),
                                (v195/*: any*/),
                                (v197/*: any*/),
                                (v199/*: any*/),
                                (v204/*: any*/),
                                (v209/*: any*/),
                                (v211/*: any*/),
                                (v212/*: any*/),
                                (v213/*: any*/),
                                (v215/*: any*/),
                                (v216/*: any*/),
                                (v217/*: any*/),
                                (v218/*: any*/),
                                (v219/*: any*/),
                                (v223/*: any*/),
                                (v224/*: any*/),
                                (v225/*: any*/),
                                (v226/*: any*/)
                              ],
                              "type": "JiraIssueField",
                              "abstractKey": "__isJiraIssueField"
                            }
                          ]
                        },
                        (v228/*: any*/),
                        (v58/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOptionConnection",
                              "kind": "LinkedField",
                              "name": "selectedOptions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraOptionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v190/*: any*/),
                                    (v58/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraCheckboxesField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOption",
                              "kind": "LinkedField",
                              "name": "fieldOption",
                              "plural": false,
                              "selections": [
                                (v187/*: any*/),
                                (v44/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraSingleSelectField"
                        }
                      ]
                    },
                    (v233/*: any*/)
                  ]
                },
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isJiraListRowFieldConnection"
                }
              ]
            },
            (v58/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "shouldQueryConditionalFormatting",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v135/*: any*/),
                                  "concreteType": "JiraComponentConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedComponentsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponentEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraComponent",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "ScalarField",
                                              "name": "componentId"
                                            },
                                            (v44/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedComponentsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraComponentsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v135/*: any*/),
                                  "concreteType": "JiraLabelConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedLabelsConnection",
                                  "plural": false,
                                  "selections": [
                                    (v147/*: any*/)
                                  ],
                                  "storageKey": "selectedLabelsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraLabelsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "user",
                                  "plural": false,
                                  "selections": [
                                    (v121/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraUserConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedUsersConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraUserEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v40/*: any*/),
                                            (v121/*: any*/),
                                            (v44/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v234/*: any*/),
                              "type": "JiraDatePickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v142/*: any*/)
                              ],
                              "type": "JiraDateTimePickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v235/*: any*/),
                              "type": "JiraNumberField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraPriority",
                                  "kind": "LinkedField",
                                  "name": "priority",
                                  "plural": false,
                                  "selections": [
                                    (v236/*: any*/),
                                    (v44/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraPriorityField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraProject",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v237/*: any*/),
                                    (v44/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraProjectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSprintConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedSprintsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSprintEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraSprint",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v169/*: any*/),
                                            (v44/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraSprintField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraVersion",
                                  "kind": "LinkedField",
                                  "name": "version",
                                  "plural": false,
                                  "selections": (v238/*: any*/)
                                }
                              ],
                              "type": "JiraSingleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v162/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraStatus",
                                  "kind": "LinkedField",
                                  "name": "status",
                                  "plural": false,
                                  "selections": [
                                    (v154/*: any*/),
                                    (v44/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraStatusField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v135/*: any*/),
                                  "concreteType": "JiraVersionConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedVersionsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraVersionEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraVersion",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v238/*: any*/)
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedVersionsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraMultipleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "selectedValue",
                                  "plural": false,
                                  "selections": (v239/*: any*/)
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSelectableValueConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedValues",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSelectableValueEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v239/*: any*/)
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOption",
                                  "kind": "LinkedField",
                                  "name": "selectedOption",
                                  "plural": false,
                                  "selections": [
                                    (v196/*: any*/),
                                    (v44/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraRadioSelectField"
                            },
                            {
                              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                              "kind": "Condition",
                              "passingValue": true,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v235/*: any*/),
                                  "type": "JiraNumberFormulaField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v227/*: any*/),
                                  "type": "JiraTextFormulaField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v234/*: any*/),
                                  "type": "JiraDateFormulaField"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldSets(first:500)"
},
v241 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v242 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v243 = [
  (v85/*: any*/),
  (v242/*: any*/)
],
v244 = {
  "args": (v104/*: any*/),
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v85/*: any*/),
        (v105/*: any*/),
        (v242/*: any*/)
      ]
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v243/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v243/*: any*/)
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v245 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v119/*: any*/)
          ]
        }
      ]
    }
  ]
},
v246 = [
  {
    "concreteType": "JiraIssueSearchWarning",
    "kind": "LinkedField",
    "name": "searchWarnings",
    "plural": true,
    "selections": (v109/*: any*/)
  }
],
v247 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v246/*: any*/)
},
v248 = [
  "scope"
],
v249 = {
  "kind": "Variable",
  "name": "__dynamicKey",
  "variableName": "dynamicSearchKey"
},
v250 = [
  {
    "kind": "ScalarField",
    "name": "defaultJql"
  }
],
v251 = [
  (v78/*: any*/),
  (v79/*: any*/),
  (v81/*: any*/),
  (v51/*: any*/),
  (v36/*: any*/),
  (v82/*: any*/),
  (v59/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/)
],
v252 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v253 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v254 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v65/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v236/*: any*/),
            (v77/*: any*/),
            (v165/*: any*/)
          ]
        },
        (v64/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            (v44/*: any*/),
            (v121/*: any*/),
            (v77/*: any*/),
            (v91/*: any*/),
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v94/*: any*/)
            }
          ]
        },
        (v64/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v77/*: any*/),
            {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v96/*: any*/)
              ]
            }
          ]
        },
        (v64/*: any*/),
        (v97/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": (v235/*: any*/),
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v187/*: any*/),
            (v67/*: any*/),
            (v158/*: any*/)
          ]
        },
        (v64/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v171/*: any*/)
        },
        (v64/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraLabel",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": (v159/*: any*/)
        }
      ],
      "type": "JiraJqlLabelFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v148/*: any*/),
            (v77/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGroupFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraVersion",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v198/*: any*/),
            (v77/*: any*/)
          ]
        },
        (v64/*: any*/)
      ],
      "type": "JiraJqlVersionFieldValue"
    },
    {
      "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraTownsquareProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v86/*: any*/),
                (v77/*: any*/),
                (v205/*: any*/),
                (v206/*: any*/),
                (v208/*: any*/),
                (v207/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlTownsquareProjectFieldValue"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v64/*: any*/),
        {
          "kind": "ScalarField",
          "name": "rangeStart"
        },
        {
          "kind": "ScalarField",
          "name": "rangeEnd"
        }
      ],
      "type": "JiraJqlDateBucketFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v64/*: any*/),
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v86/*: any*/),
            (v77/*: any*/),
            (v202/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            },
            {
              "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v203/*: any*/)
            }
          ]
        }
      ],
      "type": "JiraJqlGoalsFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v86/*: any*/),
            (v205/*: any*/),
            (v206/*: any*/),
            (v77/*: any*/),
            (v208/*: any*/),
            (v170/*: any*/),
            (v207/*: any*/),
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "dueDate"
                },
                {
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    (v40/*: any*/),
                    (v77/*: any*/),
                    (v91/*: any*/),
                    (v44/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraJqlTownsquareProjectFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": true,
          "selections": [
            (v77/*: any*/),
            (v95/*: any*/),
            (v44/*: any*/),
            (v162/*: any*/),
            (v114/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlIssueTypeFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v64/*: any*/),
        {
          "concreteType": "JiraResolution",
          "kind": "LinkedField",
          "name": "resolution",
          "plural": false,
          "selections": [
            (v44/*: any*/),
            (v77/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlResolutionFieldValue"
    }
  ]
},
v255 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v256 = [
  (v80/*: any*/),
  (v179/*: any*/),
  (v36/*: any*/),
  (v46/*: any*/),
  (v39/*: any*/),
  (v255/*: any*/)
],
v257 = {
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "filterByProjectKeys.0",
          "variableName": "projectKey"
        }
      ],
      "kind": "ListValue",
      "name": "filterByProjectKeys"
    }
  ],
  "concreteType": "JiraIssueEdgeChildIssuesInfo",
  "kind": "LinkedField",
  "name": "childIssuesInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "childrenCount"
    }
  ]
},
v258 = {
  "condition": "shouldQueryHasChildrenWithCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v257/*: any*/),
    {
      "args": [
        (v32/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "canHaveChildIssues"
    }
  ]
},
v259 = [
  (v78/*: any*/),
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v82/*: any*/),
  (v83/*: any*/),
  (v59/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v255/*: any*/)
],
v260 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "feature",
        "variableName": "atlassianIntelligenceProductFeature"
      }
    ],
    "kind": "ObjectValue",
    "name": "atlassianIntelligenceProductFeatureInput"
  },
  (v33/*: any*/)
],
v261 = [
  (v33/*: any*/)
],
v262 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "args": [
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          {
            "items": [
              {
                "kind": "Variable",
                "name": "projectKeys.0",
                "variableName": "projectKey"
              }
            ],
            "kind": "ListValue",
            "name": "projectKeys"
          },
          {
            "kind": "Variable",
            "name": "shouldQueryHasChildrenWithCount",
            "variableName": "shouldQueryHasChildrenWithCount"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_issueQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "shouldQueryRankField",
                "variableName": "shouldQueryRankField"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_jira"
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v34/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v30/*: any*/),
                      (v31/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "IssueNavigatorUIComponent_project_jiraProject"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "IssueSearch_issueNavigatorProject"
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v35/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "ConditionalFormattingInner"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ConditionalFormattingSidebarContainer_project"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v29/*: any*/),
      (v16/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v17/*: any*/),
      (v24/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v26/*: any*/),
      (v11/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v19/*: any*/),
      (v10/*: any*/),
      (v25/*: any*/),
      (v23/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v18/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssueAppConditionalEntrypointSsrEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueTableFlatListInitialisationFixEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisCrossGroupDndEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderGroupByAgentSessionsSubPropertyRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider"
      }
    ],
    "kind": "Operation",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v33/*: any*/),
              {
                "kind": "Variable",
                "name": "filterId",
                "variableName": "filterId"
              },
              (v36/*: any*/),
              (v37/*: any*/),
              {
                "kind": "Variable",
                "name": "namespace",
                "variableName": "namespace"
              },
              (v38/*: any*/),
              (v39/*: any*/),
              {
                "kind": "Variable",
                "name": "viewConfigInput",
                "variableName": "staticViewInput"
              },
              {
                "kind": "Variable",
                "name": "viewId",
                "variableName": "viewId"
              }
            ],
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraView"
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": (v43/*: any*/)
              },
              (v44/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v45/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "viewId"
                  },
                  {
                    "args": (v47/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFrozen"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQuerySaveResetViewSettingsButton",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canPublishViewConfig"
                      },
                      (v49/*: any*/),
                      (v50/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v52/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v58/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v36/*: any*/),
                          (v59/*: any*/),
                          (v38/*: any*/)
                        ],
                        "concreteType": "JiraJqlValidationResult",
                        "kind": "LinkedField",
                        "name": "validateJql",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                  (v40/*: any*/),
                                  (v60/*: any*/),
                                  (v41/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v49/*: any*/)
                    ]
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v52/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isGroupingEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canEnableGrouping"
                      },
                      (v54/*: any*/),
                      (v56/*: any*/),
                      (v55/*: any*/),
                      (v61/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v49/*: any*/),
                      {
                        "args": [
                          (v46/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "hasDefaultFieldSets"
                      },
                      {
                        "args": (v47/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v62/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v64/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsMetadata",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchMetadataField",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canBeConfigured"
                                                  },
                                                  (v53/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isPlaceHolderField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v58/*: any*/)
                        ]
                      },
                      (v50/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v52/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/),
                              (v61/*: any*/),
                              (v55/*: any*/),
                              (v54/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEnableReranking"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "args": (v35/*: any*/),
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v74/*: any*/)
                                  }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v58/*: any*/)
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v49/*: any*/),
                      {
                        "args": (v35/*: any*/),
                        "concreteType": "JiraFormattingRuleConnection",
                        "kind": "LinkedField",
                        "name": "conditionalFormattingRules",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "expression",
                                    "plural": false,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v69/*: any*/),
                                      (v68/*: any*/),
                                      (v70/*: any*/)
                                    ]
                                  },
                                  (v76/*: any*/),
                                  (v72/*: any*/)
                                ]
                              },
                              (v40/*: any*/)
                            ]
                          },
                          (v58/*: any*/)
                        ],
                        "storageKey": "conditionalFormattingRules(first:20)"
                      },
                      (v58/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "filterId"
                          },
                          {
                            "args": (v52/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ],
                    "type": "JiraView",
                    "abstractKey": "__isJiraView"
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v84/*: any*/),
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                      (v99/*: any*/),
                      (v102/*: any*/),
                      (v103/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v110/*: any*/),
                      (v111/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v112/*: any*/),
                              (v126/*: any*/),
                              (v240/*: any*/),
                              (v58/*: any*/)
                            ]
                          },
                          (v45/*: any*/),
                          (v241/*: any*/),
                          (v244/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "JiraListRowConnection",
                        "abstractKey": "__isJiraListRowConnection"
                      },
                      (v245/*: any*/),
                      (v58/*: any*/),
                      (v247/*: any*/)
                    ]
                  },
                  {
                    "args": (v84/*: any*/),
                    "filters": (v248/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                    "kind": "LinkedHandle",
                    "name": "issues",
                    "dynamicKey": (v249/*: any*/)
                  }
                ],
                "type": "JiraDetailedView"
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v250/*: any*/),
                    "type": "JiraDetailedView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v250/*: any*/),
                    "type": "JiraGroupedListView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v250/*: any*/),
                    "type": "JiraListView"
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v251/*: any*/),
                    "concreteType": "JiraSpreadsheetGroupConnection",
                    "kind": "LinkedField",
                    "name": "groups",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v85/*: any*/),
                          {
                            "concreteType": "JiraSpreadsheetGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v44/*: any*/),
                              (v252/*: any*/),
                              (v45/*: any*/),
                              (v53/*: any*/),
                              (v253/*: any*/),
                              (v48/*: any*/),
                              (v254/*: any*/)
                            ]
                          },
                          (v40/*: any*/)
                        ]
                      },
                      (v102/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "groupByField"
                      },
                      (v45/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v43/*: any*/)
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssueAppConditionalEntrypointSsrEnabledRelayProvider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "condition": "isPaginating",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "issuesWithIssueSearchInput",
                                    "args": (v256/*: any*/),
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v156/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v44/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "isPaginating",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroup",
                            "kind": "LinkedField",
                            "name": "firstGroup",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "alias": "issuesWithIssueSearchInput",
                                "args": (v256/*: any*/),
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v85/*: any*/),
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v239/*: any*/)
                                      },
                                      {
                                        "args": (v89/*: any*/),
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSets",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v53/*: any*/),
                                                              (v40/*: any*/),
                                                              (v63/*: any*/),
                                                              (v44/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "fieldSets(first:500)"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                      (v100/*: any*/),
                                      (v101/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v108/*: any*/),
                                      (v111/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v113/*: any*/),
                                              (v86/*: any*/),
                                              (v115/*: any*/),
                                              (v116/*: any*/),
                                              (v87/*: any*/),
                                              (v118/*: any*/),
                                              (v119/*: any*/),
                                              (v123/*: any*/),
                                              (v58/*: any*/),
                                              (v124/*: any*/),
                                              (v125/*: any*/)
                                            ]
                                          },
                                          (v112/*: any*/),
                                          {
                                            "args": (v89/*: any*/),
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                              (v40/*: any*/),
                                              (v127/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v40/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v40/*: any*/),
                                                      (v63/*: any*/),
                                                      (v48/*: any*/),
                                                      (v128/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                          (v40/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              (v40/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v229/*: any*/),
                                                                      (v231/*: any*/)
                                                                    ],
                                                                    "type": "JiraIssueField",
                                                                    "abstractKey": "__isJiraIssueField"
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v131/*: any*/),
                                                                          (v133/*: any*/),
                                                                          (v134/*: any*/),
                                                                          (v138/*: any*/),
                                                                          (v141/*: any*/),
                                                                          (v150/*: any*/),
                                                                          (v151/*: any*/),
                                                                          (v152/*: any*/),
                                                                          (v153/*: any*/),
                                                                          (v230/*: any*/),
                                                                          (v155/*: any*/),
                                                                          (v157/*: any*/),
                                                                          (v160/*: any*/),
                                                                          (v164/*: any*/),
                                                                          (v166/*: any*/),
                                                                          (v167/*: any*/),
                                                                          (v168/*: any*/),
                                                                          (v172/*: any*/),
                                                                          (v232/*: any*/),
                                                                          (v176/*: any*/),
                                                                          (v177/*: any*/),
                                                                          (v178/*: any*/),
                                                                          (v180/*: any*/),
                                                                          (v181/*: any*/),
                                                                          (v184/*: any*/),
                                                                          (v185/*: any*/),
                                                                          (v186/*: any*/),
                                                                          (v188/*: any*/),
                                                                          (v189/*: any*/),
                                                                          (v191/*: any*/),
                                                                          (v193/*: any*/),
                                                                          (v194/*: any*/),
                                                                          (v195/*: any*/),
                                                                          (v197/*: any*/),
                                                                          (v199/*: any*/),
                                                                          (v204/*: any*/),
                                                                          (v209/*: any*/),
                                                                          (v211/*: any*/),
                                                                          (v212/*: any*/),
                                                                          (v213/*: any*/),
                                                                          (v215/*: any*/),
                                                                          (v216/*: any*/),
                                                                          (v217/*: any*/),
                                                                          (v218/*: any*/),
                                                                          (v219/*: any*/),
                                                                          (v223/*: any*/),
                                                                          (v224/*: any*/),
                                                                          (v225/*: any*/),
                                                                          (v226/*: any*/)
                                                                        ],
                                                                        "type": "JiraIssueField",
                                                                        "abstractKey": "__isJiraIssueField"
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v228/*: any*/),
                                                                  (v58/*: any*/)
                                                                ]
                                                              },
                                                              (v233/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                          },
                                          (v258/*: any*/),
                                          (v58/*: any*/)
                                        ]
                                      },
                                      (v58/*: any*/)
                                    ],
                                    "type": "JiraListRowConnection",
                                    "abstractKey": "__isJiraListRowConnection"
                                  },
                                  (v58/*: any*/)
                                ]
                              },
                              {
                                "alias": "issuesWithIssueSearchInput",
                                "args": (v256/*: any*/),
                                "filters": [
                                  "viewConfigInput",
                                  "fieldSetsInput",
                                  "scope",
                                  "settings",
                                  "issueSearchInput"
                                ],
                                "handle": "connection",
                                "key": "firstGroupSection_nativeIssueTable__issuesWithIssueSearchInput",
                                "kind": "LinkedHandle",
                                "name": "issues"
                              },
                              (v45/*: any*/),
                              (v53/*: any*/),
                              (v253/*: any*/),
                              (v48/*: any*/),
                              (v254/*: any*/),
                              (v252/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueTableFlatListInitialisationFixEnabledRelayProvider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "issuesWithIssueSearchInput",
                                    "args": (v256/*: any*/),
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v113/*: any*/),
                                              (v86/*: any*/)
                                            ]
                                          },
                                          {
                                            "condition": "shouldQueryHasChildrenWithCount",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              (v257/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v58/*: any*/),
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v246/*: any*/)
                      }
                    ]
                  },
                  {
                    "args": (v251/*: any*/),
                    "filters": (v248/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                    "kind": "LinkedHandle",
                    "name": "groups",
                    "dynamicKey": (v249/*: any*/)
                  }
                ],
                "type": "JiraGroupedListView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v259/*: any*/),
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                      (v99/*: any*/),
                      (v102/*: any*/),
                      (v103/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v110/*: any*/),
                      (v111/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v112/*: any*/),
                              (v126/*: any*/),
                              (v240/*: any*/),
                              (v258/*: any*/),
                              (v58/*: any*/)
                            ]
                          },
                          (v45/*: any*/),
                          (v241/*: any*/),
                          (v244/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "JiraListRowConnection",
                        "abstractKey": "__isJiraListRowConnection"
                      },
                      (v245/*: any*/),
                      (v58/*: any*/),
                      (v247/*: any*/)
                    ]
                  },
                  {
                    "args": (v259/*: any*/),
                    "filters": (v248/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraListViewPagination__issues",
                    "kind": "LinkedHandle",
                    "name": "issues",
                    "dynamicKey": (v249/*: any*/)
                  }
                ],
                "type": "JiraListView"
              }
            ]
          },
          {
            "args": (v260/*: any*/),
            "kind": "ScalarField",
            "name": "shouldShowAtlassianIntelligence"
          },
          {
            "args": (v261/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              (v58/*: any*/),
              {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
              }
            ]
          },
          {
            "args": (v260/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianIntelligenceAction",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAccessible"
                  }
                ],
                "type": "JiraAccessAtlassianIntelligenceFeature"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  }
                ],
                "type": "JiraEnableAtlassianIntelligenceDeepLink"
              }
            ]
          },
          {
            "args": (v261/*: any*/),
            "concreteType": "JiraJqlFieldWithAliases",
            "kind": "LinkedField",
            "name": "rankField",
            "plural": false,
            "selections": [
              (v53/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/)
            ]
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v34/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v86/*: any*/),
                  (v237/*: any*/),
                  {
                    "alias": "editIssues",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_ISSUES"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": (v262/*: any*/),
                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                  },
                  {
                    "alias": "createIssues",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": (v262/*: any*/),
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                  },
                  (v120/*: any*/),
                  (v44/*: any*/),
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "allowLocalFields"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v35/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": (v74/*: any*/),
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v35/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRuleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraFormattingRule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v44/*: any*/),
                                      (v76/*: any*/),
                                      (v72/*: any*/),
                                      (v71/*: any*/)
                                    ]
                                  },
                                  (v40/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v144/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d90f9685fdc33683e28f5d615e3982868e263e0320c38efa34bb06cd801f4bd7",
    "metadata": {},
    "name": "main_IssueNavigatorQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider": isOrderByRankEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider": isNinDecoupledJqlValidationFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider": isNinIssuePreviewPanelChangeboardingEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled": isIssueSearchWarningsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraTimelineHarmonisationM3PerformanceDisabledRelayProvider": isTimelineHarmonisationM3PerformanceDisabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFrontierFormulaFieldD2D3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEditEnabled": isJiraForgeCustomFieldsInIssueNavigatorEditEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssueAppConditionalEntrypointSsrEnabledRelayProvider": isNinIssueAppConditionalEntrypointSsrEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled": isJiraSpreadsheetGroupSearchWarningsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueTableFlatListInitialisationFixEnabledRelayProvider": isIssueTableFlatListInitialisationFixEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisCrossGroupDndEnabledRelayProvider": isCrossGroupDndEnabled_provider,
      "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": isProjectsInJiraM1Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider,
      "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderGroupByAgentSessionsSubPropertyRelayProvider": isGroupByAgentSessionsSubPropertyEnabled_provider,
      "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": isPrivateGoalsInListViewGroupHeaderEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": isAdditionalFieldsInGroupByProjectHeaderEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": isGuidedAutonomyEapEnabled_provider
    }
  }
};
})();

(node as any).hash = "5076a8713e07f577126d4730c68cd825";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
